import React, { useState, Component } from 'react';
import { Share2, Twitter, Facebook, Linkedin, Link as LinkIcon, Check } from 'lucide-react';
interface SocialShareProps {
  url?: string;
  title?: string;
  description?: string;
}
export function SocialShare({
  url = typeof window !== 'undefined' ? window.location.href : '',
  title = 'ShoppingExpert.ai - AI Shopping Assistants Directory',
  description = 'Discover 100+ AI shopping assistants and expert advisors for smarter shopping decisions'
}: SocialShareProps) {
  const [copied, setCopied] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedDescription = encodeURIComponent(description);
  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
  };
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };
  return <div className="relative inline-block" data-id="element-213">
      <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center gap-2 px-4 py-2 rounded-xl border border-slate-300 bg-white hover:bg-slate-50 text-slate-700 font-medium text-sm transition-colors" aria-label="Share this page" data-id="element-214">
        <Share2 size={16} data-id="element-215" />
        Share
      </button>

      {isOpen && <>
          {/* Backdrop */}
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} data-id="element-216" />

          {/* Share Menu */}
          <div className="absolute right-0 mt-2 w-56 rounded-xl bg-white border border-slate-200 shadow-lg z-20 p-2" data-id="element-217">
            <a href={shareLinks.twitter} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50 text-slate-700 transition-colors" onClick={() => setIsOpen(false)} data-id="element-218">
              <Twitter size={18} className="text-blue-400" data-id="element-219" />
              <span className="text-sm font-medium" data-id="element-220">Share on Twitter</span>
            </a>

            <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50 text-slate-700 transition-colors" onClick={() => setIsOpen(false)} data-id="element-221">
              <Facebook size={18} className="text-blue-600" data-id="element-222" />
              <span className="text-sm font-medium" data-id="element-223">Share on Facebook</span>
            </a>

            <a href={shareLinks.linkedin} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50 text-slate-700 transition-colors" onClick={() => setIsOpen(false)} data-id="element-224">
              <Linkedin size={18} className="text-blue-700" data-id="element-225" />
              <span className="text-sm font-medium" data-id="element-226">Share on LinkedIn</span>
            </a>

            <div className="my-2 border-t border-slate-200" data-id="element-227" />

            <button onClick={copyToClipboard} className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50 text-slate-700 transition-colors w-full" data-id="element-228">
              {copied ? <>
                  <Check size={18} className="text-green-600" data-id="element-229" />
                  <span className="text-sm font-medium text-green-600" data-id="element-230">
                    Link copied!
                  </span>
                </> : <>
                  <LinkIcon size={18} className="text-slate-600" data-id="element-231" />
                  <span className="text-sm font-medium" data-id="element-232">Copy link</span>
                </>}
            </button>
          </div>
        </>}
    </div>;
}